// extracted by mini-css-extract-plugin
export var buttonContent = "_47-0";
export var centered = "_47-1";
export var centeredFlex = "_47-2";
export var errorText = "_47-3";
export var icon = "_47-4";
export var iconButtonContent = "_47-5";
export var monospace = "_47-6";
export var padded = "_47-7";